import React from 'react';
import styled from 'styled-components';

import Destination from 'shared/components/Destination';
import DestinationDetailViewer from 'shared/components/DestinationDetailViewer';
import { Destination as DestinationEntity } from 'shared/types/destination';

import FlowLabeledContent from '../FlowLabeledContent';
import WorkflowFlowBox from '../WorkflowFlowBox';

import { WorkflowDestinationBoxProps } from './types';

const StyledContainer = styled.div`
  display: inline-flex;
`;

const renderDestinationIcon = (destination: DestinationEntity) => (
  <FlowLabeledContent label='Destination'>
    <Destination destination={destination} withLabel={false} />
  </FlowLabeledContent>
);

const WorkflowDestinationBox = ({
  isOpen,
  workflow,
}: WorkflowDestinationBoxProps) => {
  const { guid: workflowGuid, destination } = workflow;

  if (!destination || !workflowGuid) {
    return null;
  }

  return (
    <StyledContainer>
      {isOpen
        ? <DestinationDetailViewer
            destination={destination}
            workflowGuid={workflowGuid}
          />
        : <WorkflowFlowBox
            contentWhenIsClosed={renderDestinationIcon(destination)}
          />
      }
    </StyledContainer>
  );
};

export default WorkflowDestinationBox;
